<template>
    <div class="auth-container">
        <el-card class="auth-card">
            <div class="lang_select">
                <el-dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{ selectedLocale
                        }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            v-for="item in languages"
                            :key="item.value"
                            :command="item.value"
                            >{{ item.label }}</el-dropdown-item
                        >
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-tabs v-model="activeTab" stretch @tab-click="resetForms">
                <el-tab-pane :label="$t('Login')" name="login">
                    <el-form
                        :model="loginForm"
                        :rules="loginRules"
                        ref="loginForm"
                        @submit.native.prevent="handleLogin"
                    >
                        <el-form-item prop="accountType">
                            <el-select
                                v-model="loginForm.accountType"
                                placeholder=""
                            >
                                <el-option
                                    :label="$t('Email')"
                                    value="email"
                                ></el-option>
                                <el-option
                                    :label="$t('Phone')"
                                    value="mobile"
                                ></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item
                            v-if="loginForm.accountType === 'email'"
                            prop="email"
                        >
                            <el-input
                                v-model="loginForm.email"
                                :placeholder="$t('accountRequired')"
                                prefix-icon="el-icon-message"
                            ></el-input>
                        </el-form-item>

                        <template v-else>
                            <el-form-item prop="mobile">
                                <el-input
                                    v-model="loginForm.mobile"
                                    :placeholder="$t('accountRequired')"
                                >
                                    <el-select
                                        slot="prepend"
                                        v-model="loginForm.areaCode"
                                        style="width: 110px"
                                    >
                                        <el-option
                                            v-for="item in areaCodes"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select>
                                </el-input>
                            </el-form-item>
                        </template>

                        <el-form-item prop="password">
                            <el-input
                                v-model="loginForm.password"
                                type="password"
                                :placeholder="$t('passwordRequired')"
                                prefix-icon="el-icon-lock"
                                show-password
                            ></el-input>
                        </el-form-item>

                        <div class="forgot_password_text">
                            <router-link to="/forgot-password">{{
                                $t('forgotPassword')
                            }}</router-link>
                        </div>

                        <el-form-item>
                            <el-button
                                type="primary"
                                native-type="submit"
                                style="width: 100%"
                            >
                                {{ $t('Login') }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>

                <el-tab-pane :label="$t('Signup')" name="register">
                    <el-form
                        :model="registerForm"
                        :rules="registerRules"
                        ref="registerForm"
                        @submit.native.prevent="handleRegister"
                    >
                        <el-form-item prop="accountType">
                            <el-select
                                v-model="registerForm.accountType"
                                placeholder=""
                            >
                                <el-option
                                    :label="$t('Email')"
                                    value="email"
                                ></el-option>
                                <el-option
                                    :label="$t('Phone')"
                                    value="mobile"
                                ></el-option>
                            </el-select>
                        </el-form-item>

                        <!-- 邮箱注册 -->
                        <template v-if="registerForm.accountType === 'email'">
                            <el-form-item prop="email">
                                <el-input
                                    v-model="registerForm.email"
                                    :placeholder="$t('emailRequired')"
                                    prefix-icon="el-icon-message"
                                >
                                    <!-- <el-button
                                        slot="append"
                                        :disabled="isSending"
                                        @click="sendCode('email')"
                                    >
                                        {{ codeButtonText }}
                                    </el-button> -->
                                </el-input>
                            </el-form-item>
                        </template>

                        <!-- 手机号注册 -->
                        <template v-else>
                            <el-form-item prop="mobile">
                                <el-input
                                    v-model="registerForm.mobile"
                                    :placeholder="$t('phoneRequired')"
                                >
                                    <el-select
                                        slot="prepend"
                                        v-model="registerForm.areaCode"
                                        style="width: 110px"
                                    >
                                        <el-option
                                            v-for="item in areaCodes"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select>
                                </el-input>
                            </el-form-item>
                        </template>

                        <!-- 验证码输入 -->
                        <el-form-item prop="code">
                            <el-input
                                v-model="registerForm.code"
                                :placeholder="$t('codeFormat')"
                                prefix-icon="el-icon-mobile"
                            >
                                <el-button
                                    slot="append"
                                    type="success"
                                    :disabled="isSending"
                                    @click="sendCode(registerForm.accountType)"
                                >
                                    {{ codeButtonText }}
                                </el-button>
                            </el-input>
                            <div
                                v-if="registerForm.accountType === 'email'"
                                class="folder-notice"
                            >
                                <b>{{ $t('checkFolderNotice') }}</b>
                            </div>
                        </el-form-item>

                        <el-form-item prop="password">
                            <el-input
                                v-model="registerForm.password"
                                type="password"
                                :placeholder="$t('passwordRequired')"
                                prefix-icon="el-icon-lock"
                                show-password
                            ></el-input>
                        </el-form-item>

                        <el-form-item prop="confirmPassword">
                            <el-input
                                v-model="registerForm.confirmPassword"
                                type="password"
                                :placeholder="$t('comfirmPassowrdNotice')"
                                prefix-icon="el-icon-lock"
                                show-password
                            ></el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-button
                                type="success"
                                native-type="submit"
                                style="width: 100%"
                            >
                                {{ $t('Signup') }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
            <div class="footer_notice">{{ $t('copyright') }}</div>
        </el-card>
    </div>
</template>

<script>
import { login, sendCode, signup } from '@/api/user'
import { createErrorHandler } from '@/utils/errorHandler'
export default {
    data() {
        const validatePasswordConfirm = (rule, value, callback) => {
            if (value !== this.registerForm.password) {
                callback(new Error(this.$t('vertifyNewAndOldPassword')))
            } else {
                callback()
            }
        }
        const validateAccount = (rule, value, callback) => {
            const type = this.registerForm.accountType
            if (type === 'email') {
                if (!value) return callback(new Error(this.$t('emailRequired')))
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                    return callback(new Error(this.$t('emailFormat')))
                }
            } else {
                if (!value) return callback(new Error(this.$t('phoneRequired')))
                if (!/^\d{5,20}$/.test(value)) {
                    return callback(new Error(this.$t('phoneFormat')))
                }
            }
            callback()
        }

        return {
            activeTab: 'login',
            areaCodes: [
                { value: '55', label: '+55' }
                /* { value: '852', label: '+852' } */
            ],
            loginForm: {
                accountType: 'email',
                email: '',
                mobile: '',
                areaCode: '55',
                password: ''
            },
            isSending: false,
            countdown: 0,
            registerForm: {
                accountType: 'email',
                email: '',
                mobile: '',
                areaCode: '55',
                password: '',
                confirmPassword: '',
                code: ''
            },
            registerRules: {
                email: [{ validator: validateAccount, trigger: 'blur' }],
                mobile: [{ validator: validateAccount, trigger: 'blur' }],
                code: [
                    {
                        required: true,
                        message: '',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^\d{6}$/,
                        message: '',
                        trigger: 'blur'
                    }
                ],
                password: [
                    { required: true, message: '', trigger: 'blur' },
                    {
                        min: 6,
                        max: 20,
                        message: '',
                        trigger: 'blur'
                    }
                ],
                confirmPassword: [
                    {
                        required: true,
                        message: '',
                        trigger: 'blur'
                    },
                    { validator: validatePasswordConfirm, trigger: 'blur' }
                ]
            },
            loginRules: {
                email: [
                    {
                        required: true,
                        message: '',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: '',
                        trigger: 'blur'
                    }
                ],
                mobile: [
                    {
                        required: true,
                        message: '',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^\d{5,20}$/,
                        message: '',
                        trigger: 'blur'
                    }
                ],
                password: [
                    { required: true, message: '', trigger: 'blur' },
                    {
                        min: 6,
                        max: 20,
                        message: '',
                        trigger: 'blur'
                    }
                ]
            },
            selectedLocale: '',
            languages: [
                { value: 'en', label: 'English' },
                { value: 'pt', label: 'Português' }
            ]
        }
    },
    computed: {
        codeButtonText() {
            return this.countdown > 0
                ? `${this.countdown}s`
                : this.$t('sendCode')
        }
    },
    created() {
        this.showLang(this.$i18n.locale)
        this.setValidationMessage()
    },
    mounted() {
        this.errorHandler = createErrorHandler(this)
    },
    methods: {
        resetForms() {
            this.$refs.loginForm.resetFields()
            this.$refs.registerForm.resetFields()
        },
        handleLogin() {
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    // 处理登录逻辑
                    login({
                        digitalCode:
                            this.loginForm.accountType == 'email'
                                ? ''
                                : this.loginForm.areaCode,
                        loginType:
                            this.loginForm.accountType == 'email' ? 2 : 3,
                        username:
                            this.loginForm.accountType == 'email'
                                ? this.loginForm.email
                                : this.loginForm.mobile,
                        password: this.$md5(this.loginForm.password.trim())
                    })
                        .then((data) => this.errorHandler.handleResponse(data))
                        .then((res) => {
                            if (res.code == 200) {
                                this.$store.dispatch('login', res.data)
                                this.$router.push('/')
                            } /* else {
                                this.$message.error(res.message)
                            } */
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }
            })
        },
        // 注册逻辑修改
        handleRegister() {
            this.$refs.registerForm.validate((valid) => {
                if (valid) {
                    // 实际注册逻辑需要调用API
                    signup({
                        contact:
                            this.registerForm.accountType == 'email'
                                ? this.registerForm.email
                                : this.registerForm.mobile,
                        digitalCode:
                            this.registerForm.accountType == 'email'
                                ? ''
                                : this.registerForm.areaCode,
                        password: this.$md5(this.registerForm.password.trim()),
                        verificationCode: this.registerForm.code.trim()
                    })
                        .then((data) => this.errorHandler.handleResponse(data))
                        .then((res) => {
                            if (res.code == 200) {
                                this.$store.dispatch('login', res.data)
                                this.$router.push('/')
                            } /* else {
                                this.$message.error(res.message)
                            } */
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }
            })
        },
        // 发送验证码逻辑
        async sendCode(type) {
            try {
                // 验证表单字段
                const valid =
                    type === 'email'
                        ? this.registerForm.email
                        : this.registerForm.mobile

                if (!valid) {
                    if (type === 'email') {
                        this.$message.warning(this.$t('emailRequired'))
                    } else {
                        this.$message.warning(this.$t('phoneRequired'))
                    }
                    /* this.$message.warning(
                        `请先输入${type === 'email' ? '邮箱' : '手机号'}`
                    ) */
                    return
                }

                this.isSending = true
                this.countdown = 60

                // 模拟API请求
                // await new Promise((resolve) => setTimeout(resolve, 1000))

                // 实际需要调用发送验证码接口
                const responseData = await sendCode({
                    contact:
                        type === 'email'
                            ? this.registerForm.email
                            : this.registerForm.mobile,
                    digitalCode:
                        type === 'email' ? '' : this.registerForm.areaCode
                })
                this.errorHandler.handleResponse(responseData).then((res) => {
                    if (res.code == 200) {
                        this.$message.success(this.$t('sendCodeSuccess'))
                        const timer = setInterval(() => {
                            if (this.countdown > 0) {
                                this.countdown--
                            } else {
                                this.isSending = false
                                clearInterval(timer)
                            }
                        }, 1000)
                    } else {
                        this.isSending = false
                    }
                })
            } catch (error) {
                this.isSending = false
                this.countdown = 0
                this.$message.error(this.$t('sendCodeFailed'))
            }
        },
        setValidationMessage() {
            // signup
            this.registerRules.code[0].message = this.$t('codeRequired')
            this.registerRules.code[1].message = this.$t('codeFormat')
            this.registerRules.password[0].message = this.$t('passwordRequired')
            this.registerRules.password[1].message = this.$t('passwordFormat')
            this.registerRules.confirmPassword[0].message = this.$t(
                'comfirmPassowrdNotice'
            )
            // login
            this.loginRules.email[0].message = this.$t('emailRequired')
            this.loginRules.email[1].message = this.$t('emailFormat')
            this.loginRules.mobile[0].message = this.$t('phoneRequired')
            this.loginRules.mobile[1].message = this.$t('phoneFormat')
            this.loginRules.password[0].message = this.$t('passwordRequired')
            this.loginRules.password[1].message = this.$t('passwordFormat')
        },
        showLang(value) {
            for (let i = 0; i < this.languages.length; i++) {
                if (this.languages[i].value == value) {
                    this.selectedLocale = this.languages[i].label
                }
            }
        },
        handleCommand(command) {
            this.$i18n.locale = command
            this.showLang(command)
            localStorage.setItem('locale', command)
            this.setValidationMessage()
        }
    }
}
</script>

<style scoped>
.auth-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f0f2f5;
    background-image: url('~@/assets/img/backgroud.png');
}

.auth-card {
    width: 90%;
    max-width: 500px;
    margin: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.footer_notice {
    text-align: center;
    font-size: 12px;
    color: #999ba8;
}
.forgot_password_text {
    font-size: 12px;
    color: #999ba8;
    margin-bottom: 20px;
}
.lang_select {
    text-align: right;
    cursor: pointer;
}
.folder-notice {
    font-size: 10px;
    color: gray;
    line-height: 1;
    margin: 8px 0;
}
@media (max-width: 768px) {
    .auth-card {
        width: 95%;
        margin: 10px;
    }

    .el-select {
        width: 100px !important;
    }
}
.el-input-group__append .el-button {
    background: #67c23a;
    color: #ffffff;
}
</style>